import React, { useState } from 'react'
import * as Theme from '@styles/theme-const'
import PropTypes from 'prop-types'
import ModalWindow from '@shared/ModalWindow/ModalWindow'
import * as S from './BasketController.styled'
import Button from '@shared/Button/Button'
import { ChangerGood } from 'src/features/add-basket/changer-good'
import { useFeaturesMap } from '@entities/goods-features/hooks'
import { useAddBasketHandler } from 'src/features/add-basket/hooks'
import { MessageSelectShipmentMobile } from '@mobileComponents/catalog/MessageSelectShipment/MessageSelectShipmentMobile'
import { getFeatureHtml } from '@services/catalogService'

const BasketController = ({ good }) => {
    const features = useFeaturesMap()
    const addBasketItem = useAddBasketHandler()
    const [isShowedModalDemand, setIsShowedModalDemand] = useState(false)
    const [isShowedModalNotSelectedShipment, setIsShowedModalNotSelectedShipment] = useState(false)

    const toggleDemandModal = () => {
        setIsShowedModalDemand(!isShowedModalDemand)
    }

    const addBasket = () => addBasketItem(good)
    return (
        <React.Fragment>
            {isShowedModalNotSelectedShipment && (
                <MessageSelectShipmentMobile
                    closeHandler={() => setIsShowedModalNotSelectedShipment(!isShowedModalNotSelectedShipment)}
                    addBasketHandler={addBasket}
                />
            )}
            <ChangerGood>{good}</ChangerGood>
            {isShowedModalDemand && (
                <ModalWindow
                    title="Внимание"
                    isMobile
                    footer={
                        <S.FooterFuterBlock>
                            <Button elementSizeTypeValue={Theme.ElementSizeType.regular} clickHandler={addBasket}>
                                В корзину
                            </Button>
                            <Button
                                elementSizeTypeValue={Theme.ElementSizeType.regular}
                                clickHandler={toggleDemandModal}>
                                Отмена
                            </Button>
                        </S.FooterFuterBlock>
                    }
                    cancel={{
                        text: 'Отмена',
                        clickHandler: toggleDemandModal
                    }}>
                    <S.BodyModel
                        dangerouslySetInnerHTML={{
                            __html: getFeatureHtml(good, features)
                        }}
                    />
                </ModalWindow>
            )}
        </React.Fragment>
    )
}

BasketController.propTypes = {
    count: PropTypes.number,
    webId: PropTypes.number,
    shipment: PropTypes.any,
    good: PropTypes.object.isRequired
}

export default BasketController
